{
  "ts": 1747238184,
  "tsCommit": 1747238147,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "51485d2",
  "ver": "20250514_1556_WebSignup_prod_51485d2",
  "env": "production",
  "isBranchDeployment": false
}
